import React from "react";
import FormField from "../components/FormField";
import DateField from "../components/DateField";

export default function Step1PersonalInfo({ data, onChange, flowType }) {
  const isSinglePersonMode = flowType === "single-person";

  return (
    <div>
      <h2 className="text-lg font-bold text-navy">اطلاعات هویتی فروشنده</h2>
      <p className="mt-1 text-sm text-gray-500">
        اطلاعات شناسایی فروشنده را مطابق کارت ملی و شناسنامه وارد کنید.
      </p>
      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
        <FormField
          label="نام"
          name="firstName"
          value={data.firstName}
          onChange={onChange}
          placeholder="مثلاً علی"
          required
        />
        <FormField
          label="نام خانوادگی"
          name="lastName"
          value={data.lastName}
          onChange={onChange}
          placeholder="مثلاً محمدی"
          required
        />
        <FormField
          label="نام پدر"
          name="fatherName"
          value={data.fatherName}
          onChange={onChange}
          placeholder="مثلاً حسن"
          required
        />
        <FormField
          label="شماره شناسنامه"
          name="idNumber"
          value={data.idNumber}
          onChange={onChange}
          placeholder="شماره شناسنامه"
          required
        />
        <FormField
          label="کد ملی"
          name="nationalCode"
          value={data.nationalCode}
          onChange={onChange}
          placeholder="کد ملی ۱۰ رقمی"
          required
        />
        <FormField
          label="محل صدور شناسنامه"
          name="idIssuePlace"
          value={data.idIssuePlace}
          onChange={onChange}
          placeholder="مثلاً تهران"
          required
        />
        <DateField
          label="تاریخ تولد"
          name="birthDate"
          value={data.birthDate}
          onChange={onChange}
          required
        />
        <FormField
          label="تلفن همراه"
          name="mobile"
          type="tel"
          value={data.mobile}
          onChange={onChange}
          placeholder="مثلاً ۰۹۱۲۱۲۳۴۵۶۷"
          required
        />
        <FormField
          label="تلفن ثابت"
          name="phone"
          type="tel"
          value={data.phone}
          onChange={onChange}
          placeholder="مثلاً ۰۲۱۸۸۸۸۸۸۸۸"
        />
        <FormField
          label="آدرس"
          name="address"
          type="textarea"
          value={data.address}
          onChange={onChange}
          placeholder="آدرس کامل محل سکونت"
          full
          required
        />
      </div>

      {isSinglePersonMode && (
        <div className="mt-8 rounded-2xl border border-sky/20 bg-sky/5 p-4 sm:p-5">
          <h3 className="text-base font-bold text-navy">
            اطلاعات هویتی خریدار
          </h3>
          <p className="mt-1 text-sm text-gray-500">
            چون این ثبت یک‌نفره انجام می‌شود، اطلاعات خریدار را هم همینجا وارد
            کنید.
          </p>
          <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2">
            <FormField
              label="نام خریدار"
              name="buyerFirstName"
              value={data.buyerFirstName}
              onChange={onChange}
              placeholder="مثلاً رضا"
              required
            />
            <FormField
              label="نام خانوادگی خریدار"
              name="buyerLastName"
              value={data.buyerLastName}
              onChange={onChange}
              placeholder="مثلاً رضایی"
              required
            />
            <FormField
              label="نام پدر خریدار"
              name="buyerFatherName"
              value={data.buyerFatherName}
              onChange={onChange}
              placeholder="مثلاً احمد"
              required
            />
            <FormField
              label="شماره شناسنامه خریدار"
              name="buyerIdNumber"
              value={data.buyerIdNumber}
              onChange={onChange}
              placeholder="شماره شناسنامه"
              required
            />
            <FormField
              label="کد ملی خریدار"
              name="buyerNationalCode"
              value={data.buyerNationalCode}
              onChange={onChange}
              placeholder="کد ملی ۱۰ رقمی"
              required
            />
            <FormField
              label="محل صدور شناسنامه خریدار"
              name="buyerIdIssuePlace"
              value={data.buyerIdIssuePlace}
              onChange={onChange}
              placeholder="مثلاً اصفهان"
              required
            />
            <DateField
              label="تاریخ تولد خریدار"
              name="buyerBirthDate"
              value={data.buyerBirthDate}
              onChange={onChange}
              required
            />
            <FormField
              label="تلفن همراه خریدار"
              name="buyerMobile"
              type="tel"
              value={data.buyerMobile}
              onChange={onChange}
              placeholder="مثلاً ۰۹۳۶۱۲۳۴۵۶۷"
              required
            />
            <FormField
              label="تلفن ثابت خریدار"
              name="buyerPhone"
              type="tel"
              value={data.buyerPhone}
              onChange={onChange}
              placeholder="مثلاً ۰۳۱۳۳۳۳۳۳۳۳"
            />
            <FormField
              label="آدرس خریدار"
              name="buyerAddress"
              type="textarea"
              value={data.buyerAddress}
              onChange={onChange}
              placeholder="آدرس کامل خریدار"
              full
              required
            />
          </div>
        </div>
      )}
    </div>
  );
}
